import { recipeV2Client, RecipeV2Detail } from '../../../app/services/api/recipeV2';

const PUBLISHING_FETCH_BATCH_SIZE = 8;

export const loadGovernedPublishingRecipes = async (
  recipeIds: number[],
): Promise<RecipeV2Detail[]> => {
  const uniqueIds = Array.from(new Set(recipeIds));
  const recipes: RecipeV2Detail[] = [];

  for (let index = 0; index < uniqueIds.length; index += PUBLISHING_FETCH_BATCH_SIZE) {
    const batch = uniqueIds.slice(index, index + PUBLISHING_FETCH_BATCH_SIZE);
    const details = await Promise.all(
      batch.map((id) => recipeV2Client.getRecipePublishingDetail(id)),
    );
    recipes.push(...details);
  }

  return recipes;
};
